// NAVIGATION
export const CHANGE_ROUTE = 'CHANGE_ROUTE';

// HELP POPUP
export const CLOSE_HELP = 'CLOSE_HELP';
export const SHOW_HELP = 'SHOW_HELP';
export const RESET_HELP_SECTION_TOPIC = 'RESET_HELP_SECTION_TOPIC';

// FOOTER
export const SET_FOOTER_CONFIG = 'SET_FOOTER_CONFIG';

// UPLOAD VIEW
export const SET_ASSIGNED_ARTWORK_ID = 'SET_ASSIGNED_ARTWORK_ID';

// ARTWORK DATA
export const RENAME_DESIGN = 'RENAME_DESIGN';
export const STATE_ARTWORK_IMAGE = 'STATE_ARTWORK_IMAGE';
export const STATE_ARTWORK_PROJECT = 'STATE_ARTWORK_PROJECT';
export const STATE_ARTWORK_PRODUCT_DATA = 'STATE_ARTWORK_PRODUCT_DATA';
export const STATE_ARTWORK_INFO = 'STATE_ARTWORK_INFO';
export const STATE_ARTWORK_PAPER_MATERIAL = 'STATE_ARTWORK_PAPER_MATERIAL';
export const RESET_ARTWORK_INFO = 'RESET_ARTWORK_INFO';
export const RESET_ARTWORK_PROJECT = 'RESET_ARTWORK_PROJECT';
export const RESET_ARTWORK_PRODUCT_DATA = 'RESET_ARTWORK_PRODUCT_DATA';
export const RESET_ARTWORK_IMAGE = 'RESET_ARTWORK_IMAGE';
export const RESET_ARTWORK_PAPER_MATERIAL = 'RESET_ARTWORK_PAPER_MATERIAL';

// CUSTOMIZE VIEW
export const STATE_EDITOR = 'STATE_EDITOR';
export const RESET_CUSTOMIZE_DATA = 'RESET_CUSTOMIZE_DATA';
export const SET_SNAP2EDGE_VISIBLE = 'SET_SNAP2EDGE_VISIBLE';
export const SET_SNAP2EDGE_ENABLED = 'SET_SNAP2EDGE_ENABLED';
export const SET_EDITOR_ZOOM = 'SET_EDITOR_ZOOM';
export const SET_TOOL_PANEL_OVERLAY_LAYOUT = 'SET_TOOL_PANEL_OVERLAY_LAYOUT';
export const PERFORM_ACTION = 'PERFORM_ACTION';
export const CLEANUP_ACTION = 'CLEANUP_ACTION';
export const UPDATE_CUSTOMIZE_ACTION = 'UPDATE_CUSTOMIZE_ACTION';
export const UPDATE_CUSTOMIZE_ACTIONS = 'UPDATE_CUSTOMIZE_ACTIONS';
export const CHANGE_MEASUREMENT = 'CHANGE_MEASUREMENT';
export const SET_RESIZE_PARAMS = 'SET_RESIZE_PARAMS';
export const SET_PANEL_SIZES = 'SET_PANEL_SIZES';
export const SET_SCALE_PARAMS = 'SET_SCALE_PARAMS';
export const SET_BACKGROUND_PARAMS = 'SET_BACKGROUND_PARAMS';
export const SET_IMAGE_NOT_GENERATED = 'SET_IMAGE_NOT_GENERATED';
export const ADD_WORKING_AREA_WARNING = 'ADD_WORKING_AREA_WARNING';
export const REMOVE_WORKING_AREA_WARNING = 'REMOVE_WORKING_AREA_WARNING';
export const CLEAR_WORKING_AREA_WARNINGS = 'CLEAR_WORKING_AREA_WARNINGS';
export const ADD_WORKING_AREA_MESSAGE = 'ADD_WORKING_AREA_MESSAGE';
export const REMOVE_WORKING_AREA_MESSAGE = 'REMOVE_WORKING_AREA_MESSAGE';
export const CLEAR_WORKING_AREA_MESSAGES = 'CLEAR_WORKING_AREA_MESSAGES';

// APPLY CODES VIEW
export const SET_ATB_CODES_DATA = 'SET_ATB_CODES_DATA';
export const CLEAR_ATB_CODES_DATA = 'CLEAR_ATB_CODES_DATA';
export const SET_BRAND_ID_LIST = 'SET_BRAND_ID_LIST';
export const SET_IS_AUTHORIZED = 'SET_IS_AUTHORIZED';
export const SET_APPLY_CODES_STEP = 'SET_APPLY_CODES_STEP';

// WHITE INK OPTIONS VIEW
export const SET_WHITE_INK_OPTIONS_NEEDED = 'SET_WHITE_INK_OPTIONS_NEEDED';
export const SET_WHITE_INK_OPTIONS_NEXT_DISABLED = 'SET_WHITE_INK_OPTIONS_NEXT_DISABLED';
export const SET_INCLUDES_WHITE_UNDERPRINT = 'SET_INCLUDES_WHITE_UNDERPRINT';
export const SET_WHITE_INK_OPTION = 'SET_WHITE_INK_OPTION';
export const SET_TOLERANCE = 'SET_TOLERANCE';
export const STATE_ARTWORK_PREVIEW = 'STATE_ARTWORK_PREVIEW';
export const SET_ARTWORK_PREVIEW_ZOOM = 'SET_ARTWORK_PREVIEW_ZOOM';
export const SET_LAST_CLICK_COORDINATES = 'SET_LAST_CLICK_COORDINATES';
export const SET_ADVANCED_MODE_VISIBLE = 'SET_ADVANCED_MODE_VISIBLE';
export const SET_ADVANCED_MODE_TOLERANCE_SLIDER_ENABLED = 'SET_ADVANCED_MODE_TOLERANCE_SLIDER_ENABLED';
export const SET_TOUCH_UP_MODE = 'SET_TOUCH_UP_MODE';
export const SET_DARK_MODE = 'SET_DARK_MODE';
export const RESET_WHITE_INK_OPTIONS_DATA = 'RESET_WHITE_INK_OPTIONS_DATA';

// POPUPS
export const ADD_ERROR = 'ADD_ERROR';
export const ADD_WARNING = 'ADD_WARNING';
export const CLOSE_ERROR = 'CLOSE_ERROR';
export const CLOSE_WARNING = 'CLOSE_WARNING';
export const SHOW_FINISHED_ARTWORK_INFO = 'SHOW_FINISHED_ARTWORK_INFO';
export const CLOSE_FINISHED_ARTWORK_INFO = 'CLOSE_FINISHED_ARTWORK_INFO';

// SPINNER
export const UPDATE_LOADING_MESSAGE = 'UPDATE_LOADING_MESSAGE';
export const START_LOADING = 'START_LOADING';
export const END_LOADING = 'END_LOADING';

// HEADER
export const SET_HEADER_TABS_CONFIG = 'SET_HEADER_TABS_CONFIG';
